module.exports = __webpack_public_path__ + "static/media/icon-web.a6b4eb7c.svg";